import { useEffect, useState } from 'react';
import ClientIntakeInfo from './ClientIntake';
import CustomFields from './CustomFields';
import MortgageInfo from './MortgageInfo';
import { runInnerFunction } from '../../../../compatManager';
import { Button, Card, Alert } from 'react-bootstrap';
import { ClientIntakeLoadingComponent } from '../../components/LoadingComponents';
import EmailLog from './EmailLog';

type TProps = {
    setResentUpdate: (newVal: number) => void
}

const Dashboard = (props: TProps) => {
    const [dashboardSelectedOptions, setDashboardSelectedOptions] = useState({ addIntakeFields: true })
    const [loading, setLoading] = useState(true);

    const { setResentUpdate } = props;

    useEffect(() => {
        getIntakeSelectedOption()
            .then((data) => {
                if (data) {
                    setDashboardSelectedOptions({ addIntakeFields: data })
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch(err => console.error(err));
    }, [])


    const getIntakeSelectedOption = async () => {
        try {
            const retVal = await runInnerFunction('GetIntakeOption', {});
            // Convert the string 'true' or 'false' to a boolean value and update the state
            const boolValue = retVal ? retVal === 'true' : true;
            setDashboardSelectedOptions(prevOptions => ({
                ...prevOptions,
                addIntakeFields: boolValue
            }));
            return boolValue;
        } catch (e) {
            alert(e);
        }
    }

    const handleAddIntakeInformation = async () => {
        setDashboardSelectedOptions({ addIntakeFields: true });

        try {
            runInnerFunction('UpdateIntakeInformation',
                {
                    name: 'addIntakeFields',
                    updatedVal: true
                });
        } catch (e) {
            alert(`Error in updating intake field value: ${e.message || e}`)
        }

    };

    if (loading) {
        return <ClientIntakeLoadingComponent />
    }

    return (
        <>
            <Card className="scrollable" style={{ maxHeight: '500px', height:'auto' }}>
                <Card.Header>
                    <Card.Title>Email Log</Card.Title>
                </Card.Header>

                <Card.Body>
                    <EmailLog />
                </Card.Body>
            </Card>

            {dashboardSelectedOptions.addIntakeFields === true ? (
                <>
                    <ClientIntakeInfo setResentUpdate={setResentUpdate} />
                    <CustomFields editMode={true} />
                    <MortgageInfo />
                </>
            ) : (
                <Card>
                    <Card.Header>
                        <Card.Title>Intake Information</Card.Title>
                    </Card.Header>

                        <Card.Body>
                            <Alert variant="primary">
                                Adding intake information will create a fillable form for your
                                clients. Some Realti fields are added by default, but you can
                                also create your own intake fields. Intake fields can be added on
                                a per-file basis. Alternatively, you can create intake templates
                                in your firm settings.
                            </Alert>
                        </Card.Body>

                    <Card.Footer>
                        <Button variant="primary" onClick={handleAddIntakeInformation}>
                            Add Intake Information
                        </Button>
                    </Card.Footer>
                </Card>
            )}
        </>
    );
}

export default Dashboard;